module.exports = {
      id: "play-usage",
      viewBox: "0 0 30.542 30.542",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#play",
      toString: function () {
        return this.url;
      }
    }